import type { FunctionComponent } from "react";
import styled from "styled-components";
import { AdUnit, TextAd, ShoppingAd } from "app/components/React/Table/cells/AdUnit";
import { AdPreview, H3Container } from "app/components/React/Table/cells/AdUnitStyles";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { i18nFilter } from "app/filters/i18nFilter";
import { adsTargetURL } from "app/filters/ngFilters";
import { allTrackers } from "app/services/track/track";

const onClickShoppingAd = (DestUrl: string) => {
    const targetUrl = adsTargetURL()({ DestUrl });
    window.open(targetUrl, "_blank").focus();
    /* TrackWithGuidService.trackWithGuid("paid.landing.pages.ads.inner.table.pla", "click", {
        url: DestUrl,
    }); */
};
const onClickTextAd = (DestUrl) => {
    allTrackers.dispatchTrackEvent("External Link", "click", `Table/Ad/${DestUrl || ""}`);
};
const TextAdWrapper = styled.div`
    width: 100%;
    > div {
        ${AdPreview} {
            font-size: 14px;
            margin-bottom: 4px;
        }
        ${H3Container} {
            .ad-target-url {
                max-width: 100%;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                overflow-wrap: break-word;
                display: -webkit-box;
                align-self: center;
                font-size: 16px;
                line-height: 24px;
                font-family: "DM Sans";
            }
            padding-bottom: unset;
            margin-bottom: 4px;
            display: flex;
        }
        .description {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            overflow-wrap: break-word;
            font-size: 14px;
            line-height: 20px !important;
        }
    }
`;
const AdUnitTextAd = ({
    targetUrl,
    Description,
    DestUrl,
    Title,
    onClick,
    withBorder = true,
    withPadding = true,
    DestUrlPrefix = undefined,
}) => {
    return (
        <TextAdWrapper>
            <TextAd
                Description={Description}
                DestUrl={DestUrl}
                Title={Title}
                targetUrl={targetUrl}
                onClick={onClick}
                withBorder={withBorder}
                withPadding={withPadding}
                DestUrlPrefix={DestUrlPrefix}
            />
        </TextAdWrapper>
    );
};
const ShoppingAdWrapper = styled.div``;
export const SearchAdsPageAdUnit: FunctionComponent<ITableCellProps> = (props) => {
    const targetUrl = adsTargetURL()(props.value);
    const { Title, Type, DestUrl } = props.value;
    switch (Title) {
        case "grid.upgrade":
            return <AdUnit {...props} />;
        default:
            switch (Type) {
                case "Text":
                    return (
                        <AdUnitTextAd
                            {...props?.value}
                            targetUrl={targetUrl}
                            onClick={() => onClickTextAd(DestUrl)}
                            withBorder={false}
                            withPadding={false}
                            DestUrlPrefix={i18nFilter()("pla.ads.page.ads.table.columns.addetails.ad.prefix")}
                        />
                    );
                case "Shopping":
                    const { Price, Brand, ImageUrl } = props.value;
                    return (
                        <ShoppingAdWrapper>
                            <ShoppingAd
                                {...{
                                    Title,
                                    Price,
                                    Brand,
                                    ImageUrl,
                                }}
                                onImageClick={() => onClickShoppingAd(DestUrl)}
                                onNoImageClick={() => onClickShoppingAd(DestUrl)}
                            />
                        </ShoppingAdWrapper>
                    );
            }
    }
};
